<dialog #drawer class="post-drawer" aria-labelledby="post-drawer-title" (close)="close()" (keydown)="onKeydown($event)">
    @if (opened(); as current) {
    <div class="flex h-full justify-end" (click)="close()">
        <div class="flex h-full w-full max-w-xl flex-col bg-card text-primary shadow-xl" (click)="$event.stopPropagation()">
            <header class="flex shrink-0 items-start justify-between gap-4 border-b border-border px-5 py-5">
                <div class="flex min-w-0 items-center gap-3">
                    @if (current.post.coverUrl) {
                    <img [src]="current.post.coverUrl" alt="" class="size-12 shrink-0 rounded-md object-cover" />
                    }
                    <div class="min-w-0">
                        <h2 id="post-drawer-title" class="m-0 text-2xl font-bold tracking-tight">
                            {{ current.post.creatorName || current.post.handle }}
                        </h2>
                        <p class="m-0 mt-1 text-sm text-secondary">{{ current.post.handle }}</p>
                        <p class="m-0 mt-1 text-xs text-secondary">{{ current.index + 1 }} of {{ current.total }}</p>
                    </div>
                </div>
                <button type="button" class="btn-shout-fab-secondary shrink-0" aria-label="Close" (click)="close()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4" aria-hidden="true">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                </button>
            </header>

            <div class="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-5 py-5">
                <div>
                    <h3 class="m-0 text-sm font-semibold">Caption</h3>
                    <p class="m-0 mt-2 text-sm text-secondary">{{ current.post.caption || 'No caption' }}</p>
                </div>
                <dl class="m-0 grid grid-cols-2 gap-3">
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Followers</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.followers }}</dd>
                        <p class="m-0 text-xs text-secondary">Current account size</p>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Posted</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.postedLabel }}</dd>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Views</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.views }}</dd>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Likes</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.likes }}</dd>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Comments</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.comments }}</dd>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Shares</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.shares }}</dd>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Saves</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.saves }}</dd>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Engagement</dt>
                        <dd class="m-0 mt-1 text-sm">{{ current.post.engagement }}</dd>
                    </div>
                    <div>
                        <dt class="text-xs font-bold uppercase tracking-wide text-secondary">Engagement rate</dt>
                        <dd class="m-0 mt-1 text-sm">{{ rateText(current.post.engagementRate) }}</dd>
                        <p class="m-0 text-xs text-secondary">Engagement / views</p>
                    </div>
                </dl>
                @if (current.post.postUrl) {
                <a class="btn-shout btn-shout-sm btn-shout-primary w-fit" [href]="current.post.postUrl" target="_blank"
                    rel="noopener noreferrer">View post</a>
                }
            </div>

            <footer class="flex shrink-0 items-center justify-between gap-3 border-t border-border px-5 py-4">
                <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" [disabled]="!current.hasPrevious"
                    (click)="step(-1)">Previous</button>
                <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" [disabled]="!current.hasNext"
                    (click)="step(1)">Next</button>
            </footer>
        </div>
    </div>
    }
</dialog>
